import ClaimTypeInputSwitch from 'app/components/ClaimTypeInputSwitch';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import MultilineTextInput from 'assets/components/inputs/multilineText/MultilineTextInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { isEmpty } from 'lodash';
import { ClaimCreatorOptions } from 'models/enums/ClaimCreation';
import { getVisibleDataPoints } from 'module/claims/views/claim/other/Claim.Job.DataPoints.Inputs';
import { usePublicCreateClaimProvider } from '../Hooks';
import PublicCreateClaimJobDocuments from './JobDocuments';
import PublicCreateClaimJobItemTable from './JobItemTable';
import Box from 'assets/components/box/Box';
import { isEmptyClaimJob } from 'module/claims/helper/Claim.EmptyJob';

export default function PublicCreateClaimAddJob() {
  const { lang } = getLocales();
  const publicCreateClaim = usePublicCreateClaimProvider();
  const form = publicCreateClaim.form;

  const claimJobs = form.data.claim?.claimJobs ?? [];
  const claimJob = claimJobs ? claimJobs[0] : null;
  const visibleDataPoints = getVisibleDataPoints(claimJob?.dataPoints);
  const canAddDetails = !isEmpty(visibleDataPoints);
  const canAddItems =
    !!claimJob?.claimJobItems?.length && form.data?.claimCreationOption === ClaimCreatorOptions.DEALERSHIP;
  const canViewDetails = canAddDetails || canAddItems;

  return (
    <>
      <h2>{lang.jobInfo}</h2>
      <p>{lang.jobInfoParagraph}.</p>
      <FormWrapper style={{ padding: '0 !important' }}>
        <SelectInput
          name="claimTypeId"
          label={publicCreateClaim.isContractCreation ? lang.optionalClaimType : lang.claimType}
          data={publicCreateClaim.claimTypes?.map((it) => it.displayInfo)}
          value={claimJob.claimTypeId}
          onChange={({ claimTypeId }) => publicCreateClaim.updateClaimJobClaimType({ ...claimJob, claimTypeId }, 0)}
          icon={<Icon class="fas-clipboard-list" />}
          error={
            !claimJob.claimTypeId &&
            !(publicCreateClaim.isContractCreation && isEmptyClaimJob(claimJob)) &&
            lang.required
          }
        />
        <MultilineTextInput
          name="customerComplaint"
          label={lang.customerComplaint}
          value={claimJob.customerComplaint}
          onChange={({ customerComplaint }) => publicCreateClaim.updateClaimJob({ ...claimJob, customerComplaint }, 0)}
        />
        <MultilineTextInput
          name="cause"
          label={lang.causeOfFailure}
          value={claimJob.cause}
          onChange={({ cause }) => publicCreateClaim.updateClaimJob({ ...claimJob, cause }, 0)}
        />
        <MultilineTextInput
          name="correction"
          label={lang.correctionDetails}
          value={claimJob.correction}
          onChange={({ correction }) => publicCreateClaim.updateClaimJob({ ...claimJob, correction }, 0)}
        />
      </FormWrapper>
      {canViewDetails && (
        <>
          <br />
          <hr />
          <br />
          <h2>{lang.details}</h2>
          {canAddDetails && (
            <>
              <p>{lang.jobInfoParagraph}.</p>
              <FormWrapper style={{ padding: '0 !important' }}>
                <Box
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(30em, 1fr))',
                    gap: '30px 20px',
                  }}
                >
                  <DataMap
                    data={visibleDataPoints}
                    render={({ data: detail }) => (
                      <ClaimTypeInputSwitch
                        key={detail.name}
                        detail={detail}
                        onUpdate={(value, detailId) => publicCreateClaim.updateDetail(0, value, detailId)}
                      />
                    )}
                  />
                </Box>
              </FormWrapper>
            </>
          )}
          {canAddItems && <PublicCreateClaimJobItemTable claimJob={claimJob} claimJobIndex={0} />}
        </>
      )}

      <br />
      <hr />
      <br />
      <h2>{lang.supportingDocumentation}</h2>
      <p>{lang.supportingDocumentationParagraph}</p>
      <PublicCreateClaimJobDocuments claimJob={claimJob} claimJobIndex={0} />
    </>
  );
}
